import React, { useCallback } from 'react';

import range from 'lodash/range';

import ModalDropdown from '../../common/ModalDropdown/ModalDropdown';

import WeekdaySelectionGrid from '../../WeekdaySelectionGrid/WeekdaySelectionGrid';

const WeekdayGridDropdown = ({ values = [], onValuesSelected = () => {}, disabled = false }) => {
  const renderModal = useCallback(() => (
    <WeekdaySelectionGrid
      values={values}
      onValuesSelected={onValuesSelected}
    />
  ), [values, onValuesSelected])

  const displayRange = range(0, 3);
  const displayValues = displayRange.map(index => values[index]).filter(val => val?.length);
  const hasMore = values.length > displayRange.length;

  const dropdownLabel = `${displayValues.join(', ')}${hasMore ? '...' : ''}`;

  return (
    <ModalDropdown
      renderModal={renderModal}
      dropdownLabel={dropdownLabel}
      menuWidth="288px"
      isDisabled={disabled}
      noPadding
    />
  )
}

export default WeekdayGridDropdown;
